
export interface IErrorModel {
    errorType: number;
    message: string;
    visible: boolean
}

export class ErrorModel implements IErrorModel {
    errorType = -1
    message = "";
    visible = false
}